<template>  
  <article class="pftm">
    <!-- <div class="pftm__flex-row">
      <div class="pftm__flex-row pftm__review-row pftm__space-between">
        <span class="pftm__review-stars-container">
          <product-reviews-badge :product="product" :settings="settings"></product-reviews-badge>
        </span>
      </div>
    </div> -->
    <div class="pftm__flex-row pftm__align-top">
      <div class="pftm__title-container">
        <h1 class="pftm__product-title">{{ staticProductTitle }}</h1>
        <div class="pftm__afterpay-container" v-html="afterpay"></div>
      </div>
      <div class="pftm__price-container" v-if="!customFields.hide_price">
        <span>
          <span class="pftm__price pdp-price" v-if="variant" :class="{'color-util-sale': prices.price < prices.compare_at_price }">
            {{ prices.price | money }}
          </span>
          <s class="pftm__price-compare pdp-price-compare" v-if="variant && prices.price < prices.compare_at_price">
            {{ prices.compare_at_price | money }}
          </s>
        </span>
      </div>
    </div>
    <div class="body-md u-hidden-mobile-only client-generated pftm__summary" v-if="customFields.d2_short_description">
      <span v-html="customFields.d2_short_description"></span>
    </div>
  </article>
</template>

<script>
import { badgeList, assetUrl } from '@/scripts/helpers/util'
import VLink from '@/scripts/components/buttons/VLink.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import ProductReviewsBadge from '@/scripts/components/product/ProductReviewsBadge.vue'
import lowercase from 'lodash/lowerCase'

export default {
  name: 'ProductFormTopMobile',
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    variant: Object,
    settings: Object,
    prices: Object,
    afterpay: String
  },
  model: {
    prop: 'variant'
  },
  components: {
    VLink,
    Icon,
    ProductReviewsBadge
  },
  methods: {
    lowercase,
    assetUrl,
  },
  computed: {
    subtitle () {
      const { subtitlePretext, showSKU } = this.settings
      const cfVendor = this.variant && this.variant.cf_vendor ? this.variant.cf_vendor : this.customFields.product_vendor
      const vendorText = showSKU ? this.variant.sku : cfVendor

      if (subtitlePretext && vendorText) { return subtitlePretext + ' ' + vendorText } else if (vendorText) { return vendorText }
      return ''
    },
    onSale () {
      return this.variant && this.variant.price < this.variant.compare_at_price
    },
    badges () {
      return badgeList(this.product, this.variant, this.onSale)
    },
    staticProductTitle() {
      const t = this.product.title;
      return t.substr(0, t.lastIndexOf('-'));
    }
  }
}
</script>

<style lang="scss" scoped>
  .pftm {
    padding-top: 12px;
    padding-bottom: 12px;

    > * + * {
      margin-top: 4px;
    }

    &__afterpay-container {
      margin-top: 5px;
      /deep/ .pftm__afterpay {
        @include body-xs;
        color: $color-black;
        img {
          width: 75px;
          height: auto;
          vertical-align: middle;
          padding: 0 3px;
        }
        a {
          font-size: rem(9);
          font-weight: 500;
          line-height: rem(9);
          border: 1px solid $color-off-black;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 12px;
          height: 12px;
          text-decoration: none;
          color: $color-off-black;
        }
      }
    }

    &__summary {
      padding: 10px 0;
      border-bottom: 1px solid $color-light-grey;
      .more-details-cta {
        padding-left: 5px;
      }
    }

    &__price {
      font-size: rem(20);
      @include mobile-only {
        font-size: rem(16);
      }
    }

    &__price-compare {
      color: $color-black;
      font-size: rem(13);
      line-height: 1em;
      padding-top: 8px;
    }

    &__space-between {
      justify-content: space-between;
    }

    &__product-title {
      font-size: rem(36);
      line-height: 38px;
      letter-spacing: -0.1px;
      padding-right: 12px;
      @include mobile-tablet {
        font-size: rem(24);
        line-height: 25px;
      }
    }

    &__flex-row {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      width: 100%;
    }

    &__price-container {
      flex: 1 1 auto;
      padding-top: 6px;
      > span {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }

    .link {
      text-decoration: underline;
    }

    .link::before,
    .link__content::before {
      display: none;
    }

    ::v-deep .write-review-btn-hidden {
      padding-left: 5px;
      font-size: rem(11);
      position: relative;
      top: -1px;
    }

    ::v-deep .yotpo-icon {
      font-size: rem(15) !important;
      padding-right: 1px;
      &:last-child {
        padding-right: 0;
      }
    }

    &__review-stars-container {
      height: 20px; // static height so content below doesnt jump when stars load
    }

    .badge {
      position: relative;
      top: unset;
      left: unset;
      pointer-events: none;
      float: right;
      margin-left: 8px;
      font-size: rem(12);
      padding: 2px 0;
    }

    @include tablet-up {
      display: none;
      padding-bottom: 24px - 16px;
      margin-bottom: 0;
      padding-top: 0;
    }

    &__align-top {
      align-items: flex-start !important;
    }
  }
</style>
